import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-recupera-password',
  templateUrl: './recupera-password.component.html',
  styleUrls: ['./recupera-password.component.css']
})
export class RecuperaPasswordComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  destroy$ = new Subject<boolean>();

  constructor(private formBuilder: FormBuilder, private route: Router, private networkService: NetworkService,
    private spinner: NgxSpinnerService, private toastr: ToastrManager) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]]
    });
  }

  login(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      username: this.loginForm?.controls['username'].value,

    }
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.recuperaPassword;
    this.networkService.postNoToken(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {

          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = JSON.parse(response.body);
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Reset Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.route.navigate(['/login']);
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during reset password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          console.log(typeof response);
          if (response && response.esito) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = response;
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Reset Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.route.navigate(['/login']);
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during reset password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during reset password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during reset password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      });;
  }



  loginDisabled() {
    return this.loginForm?.invalid;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
